import { Checkbox, Input, List } from 'antd';
import classNames from 'classnames';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import User from '@/components/User';
import { useFilter } from '@/contexts/FilterContext';
import { useTableGrid } from '@/contexts/tableGridContact';
import { getSelectedKeys } from '@/utils/utils';

import style from './index.less';

const ListUsers = ({ listHook, onSubmit, value, multiple, canSearch, close }) => {
  const { t } = useTranslation('admin');
  const { handleChangePage } = useTableGrid();
  const { setPage, totalPages, isFetching, data, setSize, page, size: pageSize, isLoading } = listHook();
  const { setSearch } = useFilter();
  const [dataMap, setDataMap] = useState({});

  useEffect(() => {
    if (value && value.length > 0) {
      const auxData = {};
      map(value, (el) => auxData[el] = { selected: true });
      setDataMap(auxData);
    }
  }, [value]);

  const onChange = useCallback((id, selected, record) => {
    const auxData = { ...dataMap, [id]: { selected } };
    setDataMap(auxData);
    if (multiple)
      onSubmit(getSelectedKeys(dataMap), record);
    else
      onSubmit(id, record);
    if (!multiple)
      close && close();
  }, [close, dataMap, multiple, onSubmit]);

  const paginationConfig = useMemo(() => {
    return {
      pageSize,
      hideOnSinglePage: true,
      onChange: (value) => {
        handleChangePage(value);
        setPage(value);
      },
      onShowSizeChange: (index, value) => setSize(value),
      total: totalPages,
      position: 'both',
      showSizeChanger: false,
      size: 'small',
      current: page
    };
  }, [pageSize, totalPages, page, handleChangePage, setPage, setSize]);

  return (
    <div className={classNames('text-center bg-white rounded')}>
      {canSearch && <div className={classNames('p-2')}>
        <Input.Search
          placeholder={t('user.searchPlaceholder')}
          allowClear
          enterButton
          onSearch={setSearch}
        />
      </div>}
      <div className={'max-h-64 overflow-y-auto items-center'} style={{ scrollbarWidth: 'thin' }}>
        <List
          size="small"
          pagination={paginationConfig}
          loading={isLoading || ((!data || !data.length) && isFetching)}
          dataSource={data}
          renderItem={(item, i) =>
            <List.Item
              key={i}
              onClick={() => onChange(item?._id, !dataMap[item?._id]?.selected, item)}
              className={classNames('pt-2 pb-2', style.itemList)}
            >
              <div className={'inline-flex cursor-pointer'}>
                {multiple && <Checkbox
                  className={'mr-2'}
                  checked={dataMap[item?._id]?.selected}
                  onChange={(evt) => onChange(item?._id, evt.target.checked, item)}
                />}
                <User user={item}/>
              </div>
            </List.Item>}
        />
      </div>
    </div>
  );
};

ListUsers.propTypes = {
  key: PropTypes.string,
  multiple: PropTypes.bool,
  canSearch: PropTypes.bool,
  listHook: PropTypes.func,
  onSubmit: PropTypes.func,
  value: PropTypes.any,
  visible: PropTypes.bool,
  close: PropTypes.func
};

export default memo(ListUsers);

